import { RouteRecordRaw } from 'vue-router';
import MiddlePageNetworkError from './middle-page-url-block.vue';

export const ROUTE_NAME_MIDDLE_URL_BLOCK = 'middle-page-url-block';
export const middlePageUrlBlockRouter: RouteRecordRaw[] = [
  {
    path: '/middle-page-url-block',
    name: ROUTE_NAME_MIDDLE_URL_BLOCK,
    component: MiddlePageNetworkError,
  },
];
